import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useForm = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(false);

  const getEstablishments = () => {
    setLoading(true);
    AxiosInstance.get('/establishment')
      .then((res) => {
        setEstablishments(res.data.items);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEstablishments();
  }, []);

  const back = () => {
    history.goBack();
  };

  const createContract = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('contractStartDate', formState.inputValues.contractStartDate);
    formData.append('contractEndDate', formState.inputValues.contractEndDate);
    formData.append('status', formState.inputValues.status);
    formData.append('establishment', formState.inputValues.establishment);

    AxiosInstance.post('/contract', {
      contractStartDate: formState.inputValues.contractStartDate,
      contractEndDate: formState.inputValues.contractEndDate,
      status: formState.inputValues.status,
      establishmentId: formState.inputValues.establishment,
    })
      .then((response) => {
        Swal.fire(t('contract.SUCCESS_CREATE_CONTRACT'), '', 'success');
        resetFormState();
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
          if (error.data.message.includes('ERROR_START_DATE_OVERLAP')) {
            Swal.fire(t('contract.ERROR_START_DATE_OVERLAP'), '', 'error');
          }
        } else Swal.fire(t('contract.ERROR_CREATE_CONTRACT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    contractStartDate: { value: '', validate: { required: true } },
    contractEndDate: { value: '', validate: { required: true } },
    status: { value: '', validate: { required: true } },
    establishment: { value: '', validate: { required: true } },
  };

  const { formState, submitHandler, resetFormState, field, handleErrorsServer } = FormState(inputValues, createContract);

  return {
    submitHandler,
    resetFormState,
    loading,
    field,
    establishments,
    back,
  };
};

export default useForm;
